import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbase';

const ReferencesContext = createContext({
    references: [],
    hero: null,
    loading: true,
    refresh: () => { }
});

export const useReferencesData = () => useContext(ReferencesContext);

export const ReferencesProvider = ({ children }) => {
    const [references, setReferences] = useState([]);
    const [hero, setHero] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadData = async () => {
        try {
            // Fetch references
            const refs = await pb.collection('references').getList(1, 200, { sort: '-created' })
                .catch(() => ({ items: [] }));
            setReferences(refs.items || []);

            // Fetch hero separately with extreme safety
            try {
                const heroes = await pb.collection('references_hero').getFullList({ sort: '-created', max: 1 });
                if (heroes && heroes.length > 0) {
                    setHero({
                        title: heroes[0].title || 'Références',
                        subtitle: heroes[0].subtitle || '',
                        buttons: heroes[0].buttons || []
                    });
                } else {
                    setHero(null);
                }
            } catch (heroErr) {
                // If the collection references_hero doesn't exist or is inaccessible
                console.warn("Collection 'references_hero' not found or inaccessible. Using defaults.");
                setHero(null);
            }
        } catch (err) {
            console.error("Error loading references data:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <ReferencesContext.Provider value={{ references, hero, loading, refresh: loadData }}>
            {children}
        </ReferencesContext.Provider>
    );
};
